var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-table",
    {
      attrs: {
        "data-source": _vm.tableRows,
        loading: _vm.loading,
        pagination: false,
        bordered: "",
        size: "small",
        scroll: { x: "max-content" }
      }
    },
    [
      _c("a-column", {
        attrs: {
          title: _vm.$t("lbl_category"),
          "data-index": "categoryName",
          fixed: "left",
          width: 250
        }
      }),
      _vm._l(_vm.dataSource, function(col, idx) {
        return _c(
          "a-column-group",
          { key: "period-" + idx },
          [
            _c("template", { slot: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.moment(col.dateFrom).format(_vm.defaultDateFormat)
                  ) +
                  " - " +
                  _vm._s(_vm.moment(col.dateTo).format(_vm.defaultDateFormat)) +
                  " "
              )
            ]),
            _c("a-column", {
              attrs: {
                title: _vm.$t("lbl_operating"),
                "data-index": "operating_" + idx,
                align: "right"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(text) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(text ? _vm.currencyFormat(text) : "-") +
                            " "
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _c("a-column", {
              attrs: {
                title: _vm.$t("lbl_investing"),
                "data-index": "investing_" + idx,
                align: "right"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(text) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(text ? _vm.currencyFormat(text) : "-") +
                            " "
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _c("a-column", {
              attrs: {
                title: _vm.$t("lbl_financing"),
                "data-index": "financing_" + idx,
                align: "right"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(text) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(text ? _vm.currencyFormat(text) : "-") +
                            " "
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _c("a-column", {
              attrs: {
                title: _vm.$t("lbl_net_cash_flow"),
                "data-index": "net_" + idx,
                align: "right"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(text) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(text ? _vm.currencyFormat(text) : "-") +
                            " "
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }